import React from "react";
import { Trans } from "react-i18next";
import "../styles/components/FilterCard.scss";

const FilterCard = (props: any) => {
  return (
    <span className="filterCard">
      <span>
        <img src="/icons/close.svg" onClick={props.onClose}></img>{" "}
        <span className="textInsideFilter">
          <Trans i18nKey={props.label}></Trans>
        </span>
      </span>
    </span>
  );
};

export default FilterCard;
